import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const leads = {
    "id": "BxwWll",
    "name": "Leads Management",
    "description": "Use this template for lead tracking, assignment, and management.",
    "img": "/app/static/templates/sales/leads.jpg",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Sales',
    wipeTemplateContent: true,
    demoFolderColor: 8
};

const assets = {
    "id": "2bNWl6",
    "name": "Sales Assets",
    "description": "An organized space to share and access sales content.",
    "img": "/app/static/templates/sales/assets.jpg",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Sales',
    wipeTemplateContent: true,
    demoFolderColor: 8
};

const salesPlan = {
    "id": "cjjAu9",
    "name": "Sales Plan",
    "description": "Use this template to set up sales rep and territory plans and quotas.",
    "img": "/app/static/templates/sales/sales-plan.jpg",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Sales',
    wipeTemplateContent: true,
    demoFolderColor: 8
};

const pipeline = {
    "id": "yxEyYo",
    "name": "Sales Pipeline",
    "description": "Manage sales pipeline and forecasts with this template.",
    "img": "/app/static/templates/sales/pipeline.jpg",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Sales',
    wipeTemplateContent: true,
    demoFolderColor: 8
};

const testimonials = {
    "id": "TP2pyS",
    "name": "Customer Testimonials",
    "description": "An organized library of customer testimonials approved for use.",
    "img": "/app/static/templates/sales/testimonials.jpg",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Sales',
    wipeTemplateContent: true,
    demoFolderColor: 8
};

const competitors = {
    "id": "N3L3TF",
    "name": "Competitive Analysis",
    "description": "Use this template to organize competitive research data.",
    "img": "/app/static/templates/sales/competitors.jpg",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Sales',
    wipeTemplateContent: true,
    demoFolderColor: 8
};

export default {
    id: 'sales',
    name: "Sales",
    items: [

        leads,
        pipeline,

        // todo,
        assets,

        salesPlan,

        testimonials,
        competitors

    ]
};